import React from 'react';
import { useUI } from '@contexts/ui.context';
import Modal from './modal';
import dynamic from 'next/dynamic';
import Newsletter from '../newsletter';
import { getCurrentLocationAndLanguage } from '@utils/location';
import RegionSelectorModal from '@components/other/region-selector-modal';
const SignUpBusinessOwnerGeForm = dynamic(() => import('@components/auth/sign-up-business-owner-ge'));
const SignUpBusinessOwnerIqForm = dynamic(() => import('@components/auth/sign-up-business-owner-iq'));
const LoginForm = dynamic(() => import('@components/auth/login-form'));
const SignUpBusinessOwnerForm = dynamic(() => import('@components/auth/sign-up-business-owner'));
const SignUpBusinessOwnerOwnformForm = dynamic(() => import('@components/auth/sign-up-business-owner-ownform'));
const SignUpForeignForm = dynamic(() => import('@components/auth/sign-up-form-foreign'));
const ForgetPasswordForm = dynamic(() => import('@components/auth/forget-password-form'));
const ProductPopup = dynamic(() => import('@components/product/product-popup'));
const SignUpBusinessOwnerUzForm = dynamic(() => import('@components/auth/sign-up-business-owner-uz'));
const SignUpBusinessOwnerAzForm = dynamic(() => import('@components/auth/sign-up-business-owner-az'));
const SignUpBusinessOwnerOwnformAzForm = dynamic(() => import('@components/auth/sign-up-business-owner-ownform-az'));
//const ActiveEntrepreneurForm = dynamic(() => import('@components/auth/active-entrepreneur-form'));
const SignUpBusinessOwnerKzForm = dynamic(() => import('@components/auth/sign-up-business-owner-kz'));
const SignUpBusinessOwnerKgForm = dynamic(() => import('@components/auth/sign-up-business-owner-kg'));
const GuestLoginForm = dynamic(() => import('@components/auth/guest-login-form'));
const ManagedModal: React.FC = () => {
  const {
    displayModal,
    closeModal,
    modalView
  } = useUI();
  const {
    location
  } = getCurrentLocationAndLanguage();
  return <Modal open={displayModal} onClose={closeModal} data-sentry-element="Modal" data-sentry-component="ManagedModal" data-sentry-source-file="managed-modal.tsx">
      {modalView === 'LOGIN_VIEW' && <LoginForm />}
      {modalView === 'SIGN_UP_VIEW' && (location === 'uz' ? <SignUpBusinessOwnerUzForm /> : location === 'ge' ? <SignUpBusinessOwnerGeForm /> : location === 'iq' ? <SignUpBusinessOwnerIqForm /> : location === 'az' ? <SignUpBusinessOwnerAzForm /> : location === 'kz' ? <SignUpBusinessOwnerKzForm /> : location === 'kg' ? <SignUpBusinessOwnerKgForm /> : <SignUpBusinessOwnerForm />)}
      {modalView === 'SIGN_UP_OWN_VIEW' && (location === 'az' ? <SignUpBusinessOwnerOwnformAzForm /> : <SignUpBusinessOwnerOwnformForm />)}
      {modalView === 'SIGN_UP_FOREIGN_VIEW' && <SignUpForeignForm />}
      {/* {modalView === 'SIGN_UP_ACTIVE_VIEW' && 
       (location === 'az' || location === 'kz' || location === 'kg') && <ActiveEntrepreneurForm />
       } */}
      {modalView === 'FORGET_PASSWORD' && <ForgetPasswordForm />}
      {modalView === 'PRODUCT_VIEW' && <ProductPopup />}
      {modalView === 'NEWSLETTER_VIEW' && <Newsletter />}
      {modalView === 'REGION_SELECTOR_VIEW' && <RegionSelectorModal />}
      {modalView === 'GUEST_LOGIN_VIEW' && <GuestLoginForm />}
    </Modal>;
};
export default ManagedModal;